/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { OrganizationsRequestBuilderNavigationMetadata, type OrganizationsRequestBuilder } from './organizations/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v1
 */
export interface V1RequestBuilder extends BaseRequestBuilder<V1RequestBuilder> {
    /**
     * The organizations property
     */
    get organizations(): OrganizationsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const V1RequestBuilderUriTemplate = "{+baseurl}/api/v1";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const V1RequestBuilderNavigationMetadata: Record<Exclude<keyof V1RequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    organizations: {
        navigationMetadata: OrganizationsRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
